<mat-toolbar color="primary">
        <h3>{{ 'scheduler.setup.ticketCompletionCodes.title' | translate }}</h3>
        <span class="spacer"></span>

        <button (click)="addRow()" class="button-margin-right" mat-flat-button>{{ 'scheduler.general.addRow' | translate
                }}
        </button>
        <button (click)="undo()" [disabled]="pristine" class="button-margin-right" color="warn" mat-flat-button>{{
                'scheduler.general.discardChanges' | translate }}
        </button>
        <button (click)="commit()" [disabled]="pristine" color="accent" mat-flat-button>{{
                'scheduler.general.saveChanges' | translate }}
        </button>
</mat-toolbar>
<div class="grid-container">
        <app-grid (gridEvents)="onEvent($event)" [cellClick]="onCellClick" [columns]="columns" [filter]="true"
                [showContextMenu]="true" [showDirty]="true" [showRemoveRowInContextMenu]="true"
                [store]="gridStore"></app-grid>
</div>
<mat-paginator (page)="pageEvent = $event; selectPage();" [length]="gridStore.remoteTotal"
        [pageIndex]="gridStore.currentPage - 1" [pageSizeOptions]="pageSizeOptions" [pageSize]="gridStore.pageSize"
        hidePageSize="false" showFirstLastButtons="true">
</mat-paginator>